
const m = window.require("@ember/routing/history-location");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
